import en from "./en.json";
import commonEn from "@base/locales/en.json";
import commonEs from "@base/locales/es.json";
import countriesEn from '@base/../node_modules/i18n-iso-countries/langs/en.json';
import countriesEs from '@base/../node_modules/i18n-iso-countries/langs/es.json';

import es from "./es.json";
import ar from "./ar.json";

export const messages = {
  en: {
    ...en,
    ...commonEn,
    ...countriesEn
  },
  es: {
    ...es,
    ...commonEs,
    ...countriesEs
  },
  ar: ar,
};
